export class Reviewmodel {

    page:number
    status:any

}
